import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';
import { moduleFragment } from 'module/model/module.fragments';
import { ModuleOutput } from 'module/model/module.output';

@Injectable({ providedIn: 'root' })
export class FirstCoachingPlanModuleApiQuery extends ApiQuery<
	ModuleOutput,
	void
> {
	client = 'content';
	document = gql`
		query FirstCoachingPlanModule {
			firstCoachingPlanModule {
				...Module
			}
		}
		${moduleFragment}
	`;
	method = 'firstCoachingPlanModule';
}
